<template>
  <div>
    <!--footer section start-->
    <footer class="footer-section bg-black">
      <!--footer top start-->
      <div
        class="footer-top footer-light pt-5"
      >
        <div class="container">
          <div class="row justify-content-between lllf">
            <div class="col-md-12 col-lg-12 mt-4 mt-md-0 mt-lg-0">
              <div class="row">
                <div class="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                  <div class="footer-single-col">
                    <h4 class="text-start text-white pb-3 unset-font-weight">Hours</h4>
                      
                      <p class="text-start">
                        Monday - Friday<br>
                        9am - 6pm
                      </p>
                      <p class="text-start">
                        +44 7349 970810
                      </p>
                      <p class="text-start"><a target="_blank" class="text-white paragraphLinkColor custom-underline" href="https://api.whatsapp.com/send?phone=447349970810">Whatsapp</a></p>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                  <div class="footer-single-col">
                    <h3 class="text-white text-start unset-font-weight">Follow</h3>
                      <div class="footer-single-col text-start">
                        <ul class="list-unstyled list-inline footer-social-list mb-0">
                          <li class="list-inline-item">
                            <a class="text-white"
                              href="https://www.youtube.com/@MyWingio" target="_blank"
                              ><i class="fab fa-youtube"></i
                            ></a>
                          </li>
                          <li class="list-inline-item">
                            <a class="text-white" href="https://www.instagram.com/mywingio/" target="_blank"><i class="fab fa-instagram"></i></a>
                          </li>
                          <li class="list-inline-item">
                            <a class="text-white" href="https://x.com/mywingio" target="_blank"><i class="fab fa-twitter"></i></a>
                          </li>
                          <li class="list-inline-item">
                            <a class="text-white" href="https://www.linkedin.com/in/my-wingio-a8a552305/" target="_blank"><i class="fab fa-linkedin"></i></a>
                          </li>
                        </ul>
                      </div>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                  <div class="footer-single-col">
                    <h3 class="text-white text-start unset-font-weight">Policy</h3>
                    <p class="text-start"><a class="text-white paragraphLinkColor custom-underline" href="https://www.mywingio.com/returns">Shipping & Returns</a></p>
                    <p class="text-start"><a class="text-white paragraphLinkColor custom-underline" href="https://www.mywingio.com/warranty">Warranty</a></p>
                    <p class="text-white text-start unset-font-weight" >How it works</p>
                    <p class="text-start"><a class="text-white paragraphLinkColor custom-underline" href="https://www.mywingio.com/terms-conditions" >Terms & Conditions</a></p>
                    <p class="text-start"><a class="text-white paragraphLinkColor custom-underline" href="https://www.mywingio.com/privacy">Privacy</a></p>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 mt-4 mt-md-0 mt-lg-0">
                  <div class="footer-single-col">
                    <h3 class="text-white text-start unset-font-weight">Tabnova@{{currentYear}}</h3>
                    <p class="text-start">
                      85 Great Portland Street,<br>
                      London W1W7LT,<br>
                      UK
                    </p>
                    <p class="text-start">support@mywingio.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--footer top end-->

      <!--footer bottom start-->
      
      <!--footer bottom end-->
    </footer>
    <!--footer section end-->
  </div>
</template>
<script>

import { useToast } from "vue-toast-notification";
const $toast = useToast();
export default {
  name: "Footer",
  props: {
    logo: {
      type: String,
      default: "./img/logo-light.png",
    },
    whatsappLogo: {
      type: String,
      default: "./img/whatsapp-50.png",
    },
  },
  data() {
    return {
      isDisabled: false,
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {},
  beforeMount() {},
};
</script>